<template>
  <div
    class="card-content"
    :class="{ opened: noteIsOpen }"
    :style="cardified ? 'max-width: fit-content' : null"
    @mouseleave="
      $emit('mouseLeave');
      showToolbar = false;
    "
    @mousedown.left="$emit('handleTestDragSelect', $event)"
  >
    <v-row
      no-gutters
      class="pl-0 pr-8"
      :class="{
        'bullet-row': !card && !isObjSection && !isObjDomain,
        'py-1': isObjContainer,
        'pt-0': !isObjContainer,
        'mt-4': isObjSection,
        'blue lighten-5': titleFocused && !dragSelected,
        'hover-only':
          !outline && !pageNoteLength && !titleLength && !titleFocused && index != parentPageNoteLength - 1
      }"
      style="position: relative;"
    >
      <div class="dropzone" v-if="!card && dragInProgress && parentNoteId !== dragData.id">
        <drop type="item" class="drop bullet-drop" @drop="handleItemDrop" style=""></drop>
      </div>
      <v-col
        v-if="!isObjDomain"
        class="shrink handle pa-0"
        :class="'a' + parentNoteId"
        @mousedown="$emit('dragHandleMousedown', $event)"
      >
        <v-menu
          v-model="noteMenuValue"
          offset-y
          :close-on-content-click="false"
          v-if="nested || card || !gridView"
        >
          <template v-slot:activator="{ on }">
            <!-- <v-btn
              :ripple="false"
              icon
              v-on="on"
              x-small
              class="hover-only ghost pt-1"
              style="background-color: white !important; border-radius: 4px !important;"
            > -->
            <button v-on="on" class="hover-only ghost pt-1" style="cursor: grab;">
              <oh-v-icon scale="0.8" name="md-dragindicator"></oh-v-icon>
            </button>
            <!-- </v-btn> -->
          </template>
          <flair-menu
            v-if="noteMenuValue"
            :page="page"
            :enabledFlair="enabledFlair"
            :showAddToMyPanel="onlyInOtherUser"
            :showDelete="!onlyInOtherUser"
            :showArchive="!panel || panel == 'user'"
            :showSendToTeammate="!panel || panel == 'user'"
            :showMove="!panel || panel == 'user'"
            @updateFlair="useUpdateFlair"
            @moveTo="
              openMoveTo({ selectedNoteId: parentNoteId, parentPageId });
              noteMenuValue = false;
            "
            @archive="
              handleArchivePage({ pageId, parentPageId, noteId: parentNoteId });
              noteMenuValue = false;
            "
            @open="
              openInTab({ pageId, paneId, tabId: tabId || 'active', parentPageId, parentNoteId });
              noteMenuValue = false;
            "
            @openToSide="
              createPane({ pageId, parentPageId, parentNoteId });
              noteMenuValue = false;
            "
            @selectNote="
              $emit('selectNote');
              noteMenuValue = false;
            "
            @deleteNote="
              $emit('deleteNote');
              nestedLevel === 0 && closeTab({ tabId, paneId });
              noteMenuValue = false;
            "
            @indent="$emit('indentCard', $event)"
            @deindent="$emit('deIndentCard', $event)"
            @addNewLineBelow="
              $emit('addNewLineBelow', { pageType: page.type });
              noteMenuValue = false;
            "
            @addNewLineAbove="
              $emit('addNewLineAbove', { pageType: page.type });
              noteMenuValue = false;
            "
            @moveUp="$emit('moveOrder', -1)"
            @moveDown="$emit('moveOrder', 1)"
            @moveTop="$emit('moveFirst')"
            @moveBottom="$emit('moveLast')"
            @addToMyPanel="
              addNoteToTeammate({ addToSelf: true, pageId: page.id, teammateId: panel })
            "
          ></flair-menu>
        </v-menu>
      </v-col>
      <v-col class="shrink pt-1" style="" v-if="nested && !card && !isObjDomain">
        <!-- <v-hover v-slot="{ hover }">
          <v-badge
            color="blue"
            icon="add"
            bottom
            bordered
            :value="!pageNoteLength && hover"
            style="pointer-events: none;"
          > -->
        <!-- <v-btn
              style="background: transparent; pointer-events: all;"
              icon
              :ripple="false"
              @click="pageNoteLength ? $emit('toggleShow', false) : $emit('createNewChild')"
              :class="{ 'hover-only': isBoxed && show }"
              x-small
            > -->
        <button
          @click="pageNoteLength ? $emit('toggleShow', false) : $emit('createNewChild')"
          style="background: transparent; pointer-events: all;"
          :style="!cardified ? 'visibilty: show;' : 'visibility: hidden;'"
        >
          <oh-v-icon
            v-if="pageNoteLength"
            class="grey--text"
            :class="{
              'text=--darken-1': !isObjItem && !isObjContainer,
              'text--lighten-1': isObjContainer || isObjItem
            }"
            name="md-keyboardarrowright"
            :style="show || !pageNoteLength ? 'transform: rotate(90deg);' : null"
          >
          </oh-v-icon>
          <oh-v-icon
            v-if="!pageNoteLength"
            name="md-keyboardarrowright"
            class="add-child-btn hover-only grey--text text--lighten-2"
          >
          </oh-v-icon>
          <!-- </v-btn> -->
        </button>
        <!-- </v-badge>
        </v-hover> -->
      </v-col>
      <!-- <template v-if="isObjContainer || isObjItem">
        <v-hover v-slot:default="hoverBtn">
          <v-btn
            style="position: absolute; left: 50%; margin-left: -12px; bottom: -10px; z-index: 5; border: 1px solid #e0e0e0 !important;"
            x-small
            icon
            class="white hover-only"
            @click="pageNoteLength ? $emit('toggleShow', false) : $emit('createNewChild')"
          >
            <span v-show="pageNoteLength && !hoverBtn.hover">
              {{ pageNoteLength }}
            </span>
            <oh-v-icon
              v-show="hoverBtn.hover || !pageNoteLength"
              name="md-keyboardarrowdown"
              style="transition: .1s ease transform;"
              :style="show ? 'transform: rotate(180deg)' : ''"
            ></oh-v-icon>
          </v-btn>
        </v-hover>
      </template> -->
      <v-col
        v-if="!isBoxed && !isObjDomain"
        class="shrink"
        :style="page.flair && page.flair.state == 1 ? 'opacity: 0.5;' : null"
      >
        <page-type-select
          :highlight="enabledFlair.includes('flag') && false"
          ref="cardTypeSelect"
          :page="page"
          :xsmall="isObjSection || isObjDomain"
          :small="(outline && !isObjSection) || nested"
          type="card"
          :dragSelected="dragSelected"
          :parentPageId="parentPageId"
          :enabledFlair="enabledFlair"
          @toggleCodeBlock="$refs.titleEditor.toggleCodeBlock()"
          @updateFlair="useUpdateFlair"
          @changed="$refs.titleEditor.focus()"
        ></page-type-select>
      </v-col>
      <cardify-card
        v-if="cardified"
        :page="page"
        :parentNoteId="parentNoteId"
        :parentPageId="pageId"
        @open="$emit('selectNote', note)"
      >
      </cardify-card>
      <v-col class="pa-0 ma-0" v-else>
        <v-row no-gutters>
          <v-col
            class="pl-1 pt-1"
            :class="{ 'pr-6': card }"
            @click="
              $emit('clearDragSelection');
              showToolbar === false
                ? (showToolbar = {
                    x: $el.getBoundingClientRect().x,
                    y: $el.getBoundingClientRect().y
                  })
                : (showToolbar = null);
            "
            @mouseover="!renderEditable ? $emit('setRenderEditable') : null"
          >
            <content-editor
              :readOnly="!renderEditable || !userCanEdit || clickToEdit"
              ref="titleEditor"
              class="outline-card-title"
              :class="{
                open: show,
                'title-checked': page.flair && page.flair.state == 1,
                'h1-title':
                  (!nested && !outline && !isSection) ||
                  (nestedLevel < 2 && gridMode && !isSection),
                'blue--text font-weight-medium text--darken-1': isProject,
                'font-weight-bold': page.flair && page.flair.state == 2,
                'section-title': isObjSection,
                'page-section': (isSection || isPage) && !outline && nestedLevel == 1,
                'domain-title': isObjDomain,
                'container-title': isObjContainer || isObjItem,
                'click-to-edit': card && clickToEdit,
                'drag-in-progress': dragInProgress
              }"
              :disabled="!userCanEdit"
              v-model="pageTitle"
              :placeholder="nested ? `New ${iconTypeName}...` : 'New Title'"
              allowTraversal
              allowEnterMoveText
              :emitText="false"
              :preventTab="true"
              :stopDefaultTab="true"
              :allowMarkdown="true"
              :allowFormats="true"
              :hijackCtrl="true"
              :enableLink="true"
              @keyTab="$emit('indentCard', $event)"
              @keyShiftTab="$emit('deIndentCard', $event)"
              @keyUpFirstLine="
                $emit('traverseLeaveUp', $event);
                showToolbar = false;
              "
              @keyDownLastLine="
                $emit('traverseDown', $event);
                showToolbar = false;
              "
              @keyEnter="$emit('handleEnter', $event)"
              @keyCtrlEnter="useUpdateFlair({ flair: 'check', value: !page.flair.state == 1 })"
              @keyBackspaceEmpty="handleBackspaceEmpty"
              @ctrlShiftDown="$emit('handleCtrlAltRight')"
              @ctrlShiftUp="$emit('handleCtrlAltLeft')"
              @shiftUp="!dragSelected ? $emit('selectNote') : null"
              @shiftDown="!dragSelected ? $emit('selectNote') : null"
              @ctrlA="$emit('selectNote')"
              @ctrlAltDown="$emit('moveOrder', 1)"
              @ctrlAltUp="$emit('moveOrder', -1)"
              @ctrlDown="$emit('setShow', true)"
              @ctrlUp="$emit('setShow', false)"
              @focus="
                $emit('focus');
                titleFocused = true;
              "
              @blur="
                $emit('blur');
                titleFocused = false;
              "
              @editorReady="traverseInWhenReady ? traverseIn({}) : null"
              @alt2="useUpdateFlair({ flair: 'state', value: page.flair.state == 1 ? 0 : 1 })"
              @alt1="useUpdateFlair({ flair: 'state', value: page.flair.state == 2 ? 0 : 2 })"
              @alt3="useUpdateFlair({ flair: 'state', value: 2 })"
              @mdQuestion="updatePageType({ pageId: page.id, type: '1' })"
              @mdAstrisk="updatePageType({ pageId: page.id, type: '3' })"
              @mdSemiColon="updatePageType({ pageId: page.id, type: '7' })"
              @mdExclaimation="updatePageType({ pageId: page.id, type: '2' })"
              @mdTask="updatePageType({ pageId: page.id, type: '6' })"
              @mdPound="updatePageType({ pageId: page.id, type: '8' })"
              @mdQuote="updatePageType({ pageId: page.id, type: '13' })"
              @mdSlash="updatePageType({ pageId: page.id, type: '12' })"
              @mdDash="updatePageType({ pageId: page.id, type: '0' })"
              @mdMoney="updatePageType({ pageId: page.id, type: '9' })"
              @mdBracket="updatePageType({ pageId: page.id, type: '6' })"
              @mdSquigBrack="updatePageType({ pageId: page.id, type: '19' })"
              @mdPeriod="updatePageType({ pageId: page.id, type: '0' })"
              @mdColon="updatePageType({ pageId: page.id, type: '11' })"
              @mdArrow="updatePageType({ pageId: page.id, type: '10' })"
              @mdCaret="updatePageType({ pageId: page.id, type: '5' })"
              @mdM="updatePageType({ pageId: page.id, type: '15' })"
              @ctrlAltLeft="$emit('handleCtrlAltLeft')"
              @ctrlAltRight="$emit('handleCtrlAltRight')"
            ></content-editor>
          </v-col>
        </v-row>
      </v-col>
      <v-col v-if="inArchive || inOtherPanel" class="shrink pt-1">
        <oh-v-icon
          x-small
          :name="inOtherPanel ? 'md-peoplealt' : 'md-inbox'"
          class="green--text text--lighten-3"
        ></oh-v-icon>
      </v-col>
      <v-col
        v-if="isObjSection || isObjDomain"
        class="shrink hover-only"
        :style="page.flair && page.flair.state == 1 ? 'opacity: 0.5;' : null"
        @click="$emit('addNewChild')"
      >
        <v-btn x-small icon v-tooltip="'Add a new item to section'">
          <oh-v-icon name="md-addcircleoutline"></oh-v-icon>
        </v-btn>
        <!-- <page-type-select
          :highlight="enabledFlair.includes('flag') && false"
          ref="cardTypeSelect"
          :page="page"
          :xsmall="isObjSection || isObjDomain"
          :small="(outline && !isObjSection) || nested"
          type="card"
          :dragSelected="dragSelected"
          :parentPageId="parentPageId"
          :enabledFlair="enabledFlair"
          @updateFlair="useUpdateFlair"
          @changed="$refs.titleEditor.focus()"
        ></page-type-select> -->
      </v-col>
      <v-col class="shrink pa-0" v-if="showSectionify">
        <v-btn
          small
          icon
          @click="
            useUpdateFlair({
              flair: 'section',
              enableState: 'toggle'
            })
          "
        >
          <oh-v-icon v-show="!nested" class="hover-only" x-small name="md-selectall"></oh-v-icon>
        </v-btn>
      </v-col>
      <div class="" style="position: absolute; right: 0;">
        <open-btn
          v-show="!dragSelected || dragSelectedFirst"
          :showMakeCard="(panel == 'user' || !panel) && !inArchive && !inOtherPanel"
          :dragSelectedMenu="dragSelectedFirst"
          :showDelete="false"
          :defaultOpenPane="card"
          :showRemove="panel == 'user' && (inArchive || inOtherPanel)"
          :showAddToMyPanel="onlyInOtherUser"
          @open="openNote({})"
          @openNewTab="openNote({ newTab: true })"
          @openNewPane="openNote({ newPane: true })"
          @hoverStart="hoveringOpenBtn = true"
          @hoverStop="hoveringOpenBtn = false"
          @remove="removeNoteFromPanel({ noteId: parentNoteId, pageId: parentPageId })"
          @hide="hideNote({ pageId, noteId: parentNoteId, parentPageId })"
          @makeCard="handleArchivePage({ pageId, parentPageId, noteId: parentNoteId })"
          @delete="
            $emit('deleteNote');
            nestedLevel === 0 && closeTab({ tabId, paneId });
          "
          @addToMyPanel="addNoteToTeammate({ teammateId: panel, addToSelf: true, pageId: page.id })"
          @groupSelected="handleGroupSelected"
        ></open-btn>
      </div>
    </v-row>
    <!-- <child-preview
      v-if="isObjContainer || isObjItem"
      :page="page"
      :show="show"
      @click.native="pageNoteLength ? $emit('toggleShow', false) : $emit('createNewChild')"
    ></child-preview> -->
    <!-- <v-row
      v-if="
        enabledFlair && enabledFlair.some(a => ['progress', 'rating', 'likelyhood'].includes(a))
      "
      class="pr-4 pl-9 pb-0 mt-n2"
      :class="docFocused || (titleFocused && show) ? 'grey lighten-4' : null"
      no-gutters
    >
      <v-edit-dialog v-if="enabledFlair.includes('progress')" save-text="Done">
        <v-chip x-small color="white">
          <v-progress-linear
            height="8px"
            style="min-width: 70px;"
            rounded
            :color="flairProgress < 50 ? 'amber' : flairProgress < 80 ? 'orange' : 'green'"
            :value="flairProgress"
          >
          </v-progress-linear>
        </v-chip>
        <template v-slot:input>
          <v-subheader class="pl-0 pt-2" style="height: 20px;">Progress</v-subheader>
          <v-slider
            @mousedown.stop
            style="min-width: 100px;"
            class="pb-1"
            :color="flairProgress < 50 ? 'amber' : flairProgress < 80 ? 'orange' : 'green'"
            hide-details
            dense
            track-color="grey"
            :value="flairProgress"
            @input="
              useUpdateFlair({
                flair: 'progress',
                value: $event
              })
            "
            step="10"
          ></v-slider>
        </template>
      </v-edit-dialog>
      <v-edit-dialog v-if="enabledFlair.includes('rating')">
        <v-chip x-small color="white">
          <v-rating x-small dense :value="flairRating" readonly></v-rating>
        </v-chip>
        <template v-slot:input>
          <v-subheader class="pl-0 pt-2" style="height: 20px;">Rating</v-subheader>
          <v-rating
            :value="flairRating"
            @input="
              useUpdateFlair({
                flair: 'rating',
                value: $event
              })
            "
          ></v-rating>
        </template>
      </v-edit-dialog>
      <likely-meter
        v-if="enabledFlair.includes('likelyhood')"
        :value="page.flair.likelyhood"
        @input="
          useUpdateFlair({
            flair: 'likelyhood',
            value: $event
          })
        "
      ></likely-meter>
      <v-spacer class="grow"></v-spacer>
    </v-row> -->
  </div>
</template>

<script>
import ContentEditor from '@/components/ContentEditor';
import PageTypeSelect from '@/components/ContextDoc/PageTypeIcon/PageTypeSelect';
import cardTypes from '@/components/ContextDoc/PageTypeIcon/cardTypes';
import LikelyMeter from '@/components/LikelyMeter';
import FlairMenu from './FlairMenu';

import { computed, ref, watch, inject, nextTick } from '@vue/composition-api';
import { Drop, DragAwareMixin } from 'vue-easy-dnd';
import {
  convertToCard,
  updateNote,
  deleteNote,
  updatePage,
  moveNotes,
  removeNoteFromPanel,
  addNoteToTeammate,
  hideNote
} from './use/useDocActions.js';

import useContext from '@/views/Context/use/useContext';
import useFlair from './use/useFlair';
import useWorkspace from '@/views/Context/use/useWorkspace';
import useMultiSelect from '@/views/Context/use/useMultiSelect';
import useMoveTo from '@/views/Context/components/MoveToModal/useMoveTo';
import useArchiveModal from '@/views/Context/components/ArchiveModal/useArchiveModal';
import OpenBtn from './OpenBtn';
// import ContextDoc from '@/components/ContextDoc';
import CardifyCard from './CardifyCard';
import { currentUserId } from '@/store/useAuth';
import { setFocusedEl } from '@/views/Context/components/FloatingToolBar/useFloatingToolBar';

export default {
  components: {
    ContentEditor,
    LikelyMeter,
    PageTypeSelect,
    FlairMenu,
    OpenBtn,
    CardifyCard,
    Drop
  },
  mixins: [DragAwareMixin],
  props: [
    'page',
    'pageId',
    'card',
    'pageNoteLength',
    'parentPageNoteLength',
    'show',
    'outline',
    'index',
    'renderEditable',
    'userCanEdit',
    'showDoc',
    'showParent',
    'selectedNoteBlocks',
    'dragSelected',
    'no-children',
    'editorReady',
    'slowLoad',
    'parentPageId',
    'parentNoteId',
    'focused',
    'viewed',
    'gridView',
    'nestedLevel',
    'nested',
    'showSectionify',
    'clickToEdit',
    'dragSelectedFirst',
    'cardified'
  ],
  setup(props, comp) {
    // console.log(pages);

    const { updateFlair } = useFlair();
    const useUpdateFlair = ({ flair, value = undefined, enableState = false }) => {
      const pageId = props.pageId;
      updateFlair({
        noteId: props.parentNoteId,
        parentPageId: props.parentPageId,
        pageId,
        flair,
        value,
        enableState
      });
    };
    const panel = inject('panel');
    const { getSelectedNoteIds, groupSelectedBlocks, clearSelection } = useMultiSelect();

    const pTitle = computed(() => props.page.title);
    const titleLength = computed(() => {
      const div = document.createElement('div');
      div.innerHTML = pTitle.value;
      const title = div.textContent || div.innerText || '';
      div.remove();
      return title.length;
    });
    const inArchive = computed(() => !!props.page.noteCard);
    const inOtherPanel = computed(
      () => props.page.onUserPanels && props.page.onUserPanels.length > 1
    );
    const onlyInOtherUser = computed(
      () =>
        panel &&
        panel != 'user' &&
        (!props.page.onUserPanels || !props.page.onUserPanels.includes(currentUserId.value))
    );

    const {
      setFocusedCardId,
      focusedCardId,
      editingCardId,
      setZoomedCardId,
      zoomedCardId,
      setOnlyFocus
    } = useContext();

    const docFocused = ref(false);
    watch(editingCardId, id => {
      if (id == props.pageId) {
        docFocused.value = true;
      } else if (docFocused.value) {
        docFocused.value = false;
      }
    });

    // const docFocused = computed(() => {
    //   return editingCardId.value === props.pageId;
    // });

    const colIndex = inject('colIndex');
    const gridMode = inject('gridMode');
    const paneId = inject('paneId');
    const tabId = inject('tabId');

    const { openMoveTo } = useMoveTo();
    const {
      setPageToPin,
      openInMainWindow,
      createPane,
      openInTab,
      closeTab,
      openedTabs
    } = useWorkspace();

    const noteIsOpen = computed(() => {
      if (props.outline) {
        return !!openedTabs.value.find(
          t => t.pageId == props.pageId && t.parentNoteId == props.parentNoteId
        );
      } else {
        return false;
      }
    });

    const updatePageTitle = ({ pageId, title }) => {
      updatePage({ pageId, update: { title } });
    };

    const updatePageType = ({ pageId, type }) => {
      updatePage({ pageId, update: { type } });
      console.log(comp);
      nextTick(() => {
        comp.refs.titleEditor.setCaret({});
      });
    };

    const hoveringOpenBtn = ref(false);

    const handleConvertToCard = ({ embed = false } = {}) => {
      console.log('conver to card!');
      //  pass in embed true to embed the card, otherwise we will just remove the note
      convertToCard({ pageId: props.pageId });
      if (embed) {
        // update the note.
        const update = { pageId: null, noteCardId: props.pageId };
        updateNote({ pageId: props.parentPageId, noteId: props.parentNoteId, update });
      } else {
        // remove the note
        console.log(deleteNote);
        deleteNote({ pageId: props.parentPageId, noteId: props.parentNoteId });
      }
    };

    const handleGroupSelected = async () => {
      const newIndex = await groupSelectedBlocks();
      const contextDoc = comp.parent.$parent.$parent.$parent.$parent.$parent;
      console.log(contextDoc);
      clearSelection();
      contextDoc.toggleNoteShow({ index: newIndex });
      contextDoc.focusNoteBlock({ index: newIndex });
    };

    const { handleArchivePage } = useArchiveModal();

    const iconTypeName = computed(() => {
      const type = cardTypes.find(c => c.value === Number(props.page.type));
      if (!type) {
        console.log(props.page, 'no type');
      } else {
        return type.label;
      }
    });

    const openNote = ({ newTab = false, newPane = false }) => {
      if (newTab) {
        openInTab({
          pageId: props.pageId,
          paneId,
          parentPageId: props.parentPageId,
          parentNoteId: props.parentNoteId
        });
      } else if (newPane) {
        createPane({
          pageId: props.pageId,
          parentPageId: props.parentPageId,
          parentNoteId: props.parentNoteId
        });
      } else {
        openInTab({
          pageId: props.pageId,
          paneId,
          tabId: tabId || 'active',
          parentPageId: props.parentPageId,
          parentNoteId: props.parentNoteId
        });
      }
    };

    const showToolbar = ref(false);

    // const focusFloatingToolBar = disable => {
    //   console.log('set focused floating toolbar', comp);
    //   setFocusedEl(disable ? null : comp);
    // };
    return {
      createPane,
      colIndex,
      pTitle,
      titleLength,
      docFocused,
      setFocusedCardId,
      focusedCardId,
      editingCardId,
      useUpdateFlair,
      setZoomedCardId,
      zoomedCardId,
      openMoveTo,
      setOnlyFocus,
      setPageToPin,
      openInMainWindow,
      gridMode,
      openInTab,
      tabId,
      paneId,
      getSelectedNoteIds,
      hoveringOpenBtn,
      handleConvertToCard,
      handleArchivePage,
      moveNotes,
      updatePageTitle,
      updatePageType,
      inArchive,
      inOtherPanel,
      removeNoteFromPanel,
      onlyInOtherUser,
      panel,
      addNoteToTeammate,
      handleGroupSelected,
      iconTypeName,
      showToolbar,
      // focusFloatingToolBar,
      openNote,
      hideNote,
      closeTab,
      noteIsOpen
    };
  },
  data() {
    return {
      mounted: false,
      fileHover: 0,
      showPageTextArea: false,
      traverseInWhenReady: false,
      firstShown: false,
      titleFocused: false,
      textAreaFocused: false,
      showLoader: false,
      hoverIcon: false,
      mousedown: false,
      noteMenuValue: false,
      showChildren: false
    };
  },
  mounted() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.$emit('mounted'));
    });
    // setTimeout(() => {
    //   this.$emit('mounted')
    // }, 100)
    this.mounted = true;
    // this.$emit('mounted');
    if (this.show) {
      this.firstShown = true;
    }
    if (
      this.nestedLevel < 2 ||
      (!!this.pageNoteLength && this.showDoc && !this.isPage && this.nestedLevel < 2)
    ) {
      this.showChildren = true;
      this.firstShown = true;
    }

    // this.$root.$refs[this.pageId] = this;
  },
  computed: {
    pageTitle: {
      get() {
        return { html: this.pTitle };
      },
      set(v) {
        this.showToolbar = false;
        this.updatePageTitle({ pageId: this.pageId, title: v });
      }
    },
    enabledFlair() {
      return this.page.flair && this.page.flair.enabled ? this.page.flair.enabled : [];
    },
    flairProgress() {
      return this.page.flair ? this.page.flair.progress : undefined;
    },
    flairRating() {
      return this.page.flair ? this.page.flair.rating : undefined;
    },
    flairCheck() {
      return this.page.flair ? this.page.flair.state == 1 : undefined;
    },
    flairLikely() {
      return this.page.flair ? this.page.flair.likely : undefined;
    },
    isSection() {
      return this.page.type == 10;
      // return this.page.flair.enabled.includes('section');
    },
    isProject() {
      return this.page.type == 5 || this.page.type == 19;
    },
    isPage() {
      return [8, 9, 15, 100].includes(this.page.type);
    },
    isBoxed() {
      return this.enabledFlair.includes('section');
    },
    isObjSection() {
      return this.outline && this.nestedLevel == 1 && this.page.type == 10;
    },
    isObjContainer() {
      return (
        this.outline &&
        this.nestedLevel >= 1 &&
        this.nestedLevel < 2 &&
        [19, 7, 11, 8, 15].includes(this.page.type)
      );
    },
    isObjDomain() {
      return this.outline && this.nestedLevel == 1 && this.page.type == 5;
    },
    isObjItem() {
      return (
        this.outline &&
        this.nestedLevel >= 1 &&
        this.nestedLevel < 2 &&
        ![19, 7, 11, 8, 15, 10, 5].includes(Number(this.page.type))
      );
    }
  },
  methods: {
    log(v) {
      console.log(v);
    },

    handleTestDragSelect(event) {
      console.log(event, event.target.closest('.handle'));
      const clickedHandle = !!event.target.closest('.handle');
      if (!clickedHandle) {
        this.mousedown = true;
        this.$emit('testDragSelectStart', event);
      }
    },
    openTypeMenu() {
      console.log(this.$refs.cardTypeSelect);
      this.$refs.titleEditor.blur();
      this.$refs.cardTypeSelect.open();
      // this.$nextTick(() => {
      //   this.$refs.cardTypeSelect.$el.focus();
      // });
    },
    showOrHide({ showOnly }) {
      console.log('show only is toggled');
      if (!showOnly || !this.show) {
        this.show = !this.show;
      }
      !this.show && this.titleFocused ? this.$emit('blur') : null;
      !this.firstShown ? (this.firstShown = true) : null;
    },
    scrollToCard() {
      this.$el.scrollIntoView({ behavior: 'smooth' });
    },
    async handleFileDrop(event) {
      console.log('handle file drop');
      //set dragging file to false since we are no longer dragging the file
      for (let i = 0; i <= 35; i++) {
        setTimeout(() => {
          this.updateDraggingFile({ boolValue: false });
        }, i * 10);
      }
      //add the dropped files to the page
      console.log('handle file drop', event);
      console.log('files');
      if (event.dataTransfer.files.length > 0) {
        this.showLoader = true;
        await this.addDroppedFilesToPage({ page: this.page, fileList: event.dataTransfer.files });
        this.showLoader = false;
      }
    },
    focusTitle(event) {
      if (!this.renderEditable) {
        this.$emit('setRenderEditable');
        this.$nextTick(() => this.$refs.titleEditor.setCaret(event));
      } else {
        this.$refs.titleEditor.setCaret(event);
      }
    },
    traverseIn({ prevLeft, direction = 'down', event }) {
      const traverse = () => {
        const pLeft = prevLeft || (event && event.bounds) ? event.bounds.left : 0;
        if (direction == 'down' || !this.show) {
          if (this.$refs.titleEditor) {
            this.$refs.titleEditor.setCaret({
              prevLeft: pLeft,
              direction
            });
          } else {
            this.traverseInWhenReady = true;
            // this.$nextTick(() => {
            //   this.$refs.titleEditor.setCaret({
            //     prevLeft: pLeft,
            //     direction
            //   });
            // });
          }
        } else {
          this.$refs.cardDoc.traverseInto({ event, direction });
          // }
        }
      };

      if (!this.renderEditable) {
        this.$emit('setRenderEditable');
        this.$nextTick(() => traverse());
      } else {
        traverse();
      }
    },
    handleCtrlEnter() {
      if (this.show) {
        this.$refs.cardDoc.addNewLine({ order: 0, type: 'card', pageType: 8 });
      } else {
        this.$emit('addNewLineBelow', { pageType: 8 });
      }
    },
    handleBackspaceEmpty() {
      if (this.pageNoteLength == 0) {
        this.$emit('traverseLeaveUp', {});
        this.$emit('keyBackspaceEmpty', 0);
      }
    },
    handledFocusTextAreaEditor(event) {
      console.log(event);
      if (this.textAreaFocused || event.code == 'ArrowUp' || event.code == 'ArrowDown') {
        return;
      }
      if (event.code == 'Space' || event.code == 'Enter') {
        event.preventDefault();
        this.$refs.textAreaEditor.focus();
      } else {
        this.$refs.textAreaEditor.focus();
      }
    },
    addTemplate(template) {
      this.$refs.cardDoc.addNewLine({ order: 0 });
      template.cards.forEach((t, i) => {
        this.$refs.cardDoc.addCardNote({
          html: t,
          order: i,
          pageId: this.page.id,
          cardId: false,
          type: 'card',
          pageType: 1
        });
      });
    },
    handleItemDrop(event) {
      const data = event.data;

      let noteIds = [];
      const selectedNoteIds = this.getSelectedNoteIds();
      if (selectedNoteIds.includes(data.id)) {
        //  multidrag
        noteIds = selectedNoteIds;
      } else {
        noteIds.push(data.id);
      }

      const moveToPageId = this.page.id;
      const moveFromPageId = data.fromPageId;
      const moveToPosition = 0;
      console.log('update drag', noteIds, moveToPageId, moveFromPageId, moveToPosition);
      this.moveNotes({ noteIds, moveToPageId, moveFromPageId, moveToPosition });
    }
  }
};
</script>

<style>
.container-title {
  font-weight: 500 !important;
}

.outline-card-title.click-to-edit .ql-editor,
.outline-card-title.click-to-edit .ql-editor p {
  /* font-size: 18px !important; */
  /* font-weight: 600; */
  user-select: none;
  cursor: default;
}

.outline-card-title.click-to-edit .ql-editor:hover,
.outline-card-title.click-to-edit .ql-editor p:hover {
  /* font-size: 18px !important; */
  /* font-weight: 600; */
  background: rgba(0, 0, 0, 0.02);
  border-radius: 4px;
  user-select: none;
}

.bullet-row:hover {
  background: #dfeef75e;
}
.reordering .bullet-row:hover {
  background: inherit;
}

.dropzone:hover .drop {
  top: -12px;
  bottom: -12px;
  visibility: visible;
}

.dropzone .drop {
  top: 0px;
  bottom: 0px;
  visibility: hidden;
}

.opened {
  border-right: 2px solid #2196f3;
}
</style>
